import styled from "styled-components";
export const GlobalAdminOrgDetailViewParent = styled.div ``;
